import { defineMessages } from 'react-intl';

/** "Add contact" on Contacts (`AddContactModal.tsx`): one person by hand. */
export const addContactMessages = defineMessages({
  open: { id: 'app.outreach.addContact.open', defaultMessage: 'Add contact' },
  title: { id: 'app.outreach.addContact.title', defaultMessage: 'Add a contact' },
  body: {
    id: 'app.outreach.addContact.body',
    defaultMessage:
      'Add one person you know. The address stays in your workspace and never goes into the MUSIC24 directory.',
  },
  name: { id: 'app.outreach.addContact.name', defaultMessage: 'Name' },
  email: { id: 'app.outreach.addContact.email', defaultMessage: 'Email' },
  kind: { id: 'app.outreach.addContact.kind', defaultMessage: 'Kind (optional)' },
  kindNone: { id: 'app.outreach.addContact.kindNone', defaultMessage: 'Not set' },
  note: { id: 'app.outreach.addContact.note', defaultMessage: 'Note (optional)' },
  consent: { id: 'app.outreach.addContact.consent', defaultMessage: 'I may contact this person' },
  emailBad: { id: 'app.outreach.addContact.emailBad', defaultMessage: 'Write a full email address.' },
  cancel: { id: 'app.outreach.addContact.cancel', defaultMessage: 'Cancel' },
  save: { id: 'app.outreach.addContact.save', defaultMessage: 'Add contact' },
  added: { id: 'app.outreach.addContact.added', defaultMessage: '{name} is in your contacts.' },
  known: {
    id: 'app.outreach.addContact.known',
    defaultMessage: 'This address is in your contacts already.',
  },
  suppressed: {
    id: 'app.outreach.addContact.suppressed',
    defaultMessage: 'This person asked to get no pitches from MUSIC24. We did not add them.',
  },
  failed: { id: 'app.outreach.addContact.failed', defaultMessage: 'We could not add the contact. Try again.' },
});
